<template>
    <v-dialog width="400px" :value="value" @input="toggleModal()" scrollable >
        <v-card class="error">
            <v-card-text>
                <v-row>
                    <v-col class="text-center py-4" cols="12" >
                        <v-icon color="white" size="50">warning</v-icon>
                    </v-col>
                    <v-col cols="12" class="white--text text-center">
                        <h4>
                            {{ $t('general.doYouWantToDeleteThisBusiness', {business: `${businessModule.s}`}) }}
                        </h4>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="white"
                       text
                       @click="toggleModal()">
                    {{ $t('general.cancel') }}
                </v-btn>

                <v-btn outlined
                       color="white"
                       @click="submit()"
                       :loading="loading">
                    {{ $t('general.deleteBusiness', { business: businessModule.s }) }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import notifications from '@/libs/notifications'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['businessModule'])
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async submit () {
      this.loading = true
      try {
        const businessId = this.business.UUID
        await this.$store.dispatch('deleteBusiness', businessId)
        await this.$parent.getBusinesses()
        this.loading = false
        notifications.success(this.$t('general.businessSuccessfullyDeleted', { business: this.businessModule.s }))
        this.toggleModal()
      } catch (error) {
        notifications.error(error.message)
        this.loading = false
      }
    },
    toggleModal () {
      this.$emit('clearBusiness', '')
      this.$emit('input', false)
    }
  },
  props: ['business', 'value']
}
</script>
